enum AccessGrantAction {
  SET_ACCESS_GRANT_PAGE_INFO = 'SET_ACCESS_GRANT_PAGE_INFO',
  CLEAR_ACCESS_GRANT_PAGE_INFO = 'CLEAR_ACCESS_GRANT_PAGE_INFO',
}

export default AccessGrantAction;
